import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export default async function firebaseInitialize() {
  // Initialize the Firebase app in the service worker by passing the generated config
  const firebaseConfig = {
    apiKey: "AIzaSyBzbIsPbxBlIEffxtGFx9mjQFdugGI8O7A",
    authDomain: "hmcapp-e26cf.firebaseapp.com",
    databaseURL:
      "https://hmcapp-e26cf-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "hmcapp-e26cf",
    storageBucket: "hmcapp-e26cf.appspot.com",
    messagingSenderId: "521050469222",
    appId: "1:521050469222:web:7cb601bc6c69d3da954ea7"
  };
  const vapidKey =
    "BOAccvL74Ms8RCAKVgIETFlXcnKGSJ0e1XvBDyhA49iM_nTkbFOiZVRrqXNApdw5uEsmq7xDdpzqp_rbtZzMD7c";
  const firebase = initializeApp(firebaseConfig);
  const messaging = getMessaging();

  getToken(messaging, { vapidKey: vapidKey })
    .then(currentToken => {
      if (currentToken) {
        // Send the token to your server and update the UI if necessary
        localStorage.setItem("fcm_token", currentToken);
        // ...
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
        // ...
      }
    })
    .catch(err => {
      console.log("An error occurred while retrieving token. ", err);
      // ...
    });
  onMessage(messaging, payload => {
    console.log("Message received. ", payload);
    console.log("Receiving foreground message");
    console.log(payload);
    var notificationTitle = "vue-cometchat-firebase";
    var notificationOptions = {
      body: payload.data.alert,
      icon: ""
    };

    var notification = new Notification(notificationTitle, notificationOptions);
    notification.onclick = function(event) {
      notification.close();
      console.log(event);
    };
  });
  // onBackgroundMessage(messaging, payload => {
  //   console.log(
  //     "[firebase-messaging-sw.js] Received background message ",
  //     payload
  //   );
  //   // Customize notification here
  //   const notificationTitle = "Background Message Title";
  //   const notificationOptions = {
  //     body: "Background Message body.",
  //     icon: "/firebase-logo.png"
  //   };

  //   self.registration.showNotification(notificationTitle, notificationOptions);
  // });
}
